import { gql } from '@apollo/client';

const GET_PROJECTS = gql`
    query MyQuery($organizationId: uuid, $clientId: uuid) {
        projects(where: { agency_id: { _eq: $organizationId } }) {
            agency_id
            business_id
            created_at
            details
            id
            name
            offer_id
            status
            offer {
                description
                id
                image_url
                status
                title
                updated_at
            }
            project_users {
                organization_member {
                    id
                    user {
                        first_name
                        id
                    }
                }
                organization_members_id
                project_id
            }
        }
    }
`;

const GET_PROJECTS_FOR_CLIENT = gql`
    query MyQuery($organizationId: uuid, $clientId: uuid) {
        projects(where: { agency_id: { _eq: $organizationId }, business_id: { _eq: $clientId }, _not: { status: { _eq: CANCELED } } }) {
            agency_id
            business_id
            created_at
            details
            id
            name
            offer_id
            status
            offer {
                description
                id
                image_url
                status
                title
                updated_at
            }
            project_users {
                organization_member {
                    id
                    user {
                        first_name
                        id
                    }
                }
                organization_members_id
                project_id
                id
            }
        }
    }
`;

// eslint-disable-next-line import/prefer-default-export
export { GET_PROJECTS, GET_PROJECTS_FOR_CLIENT };
